import {EventEmitter, Injectable} from '@angular/core';
import {EventDto} from './event.service';
import * as _ from 'lodash';
import {DancerDto} from './dancer.service';
import {UserService} from './user.service';
import {CookieService} from 'ngx-cookie-service';

@Injectable()
export class ShoppingCartService {

  private _data: CartData = new CartData([], [],
    null, false, false,
    '', '', '', '', '', '');
  paymentAvailableEvent = new EventEmitter<boolean>();
  priceChangedInbasket = new EventEmitter<boolean>();

  constructor(private userService: UserService,
              private cookieService: CookieService) {
    if (this.cookieService.check('basket')) {
      const v: any = JSON.parse(this.cookieService.get('basket'), addDate);
      if (this.validCart(v)) {
        const dancersMap = v.dancers;
        const ticketObjects = v.tickets.map(t => Ticket.of(t.event, t.dancerId));
        this._data = Object.assign(new CartData(null, null, null,
          false, false, '',
          '', '', '', '', ''),
          {tickets: ticketObjects, dancers: dancersMap,
            clientId: v.clientId, gdpr: v.gdpr, terms: v.terms,
          companyDisplayName: v.companyDisplayName, companyPhoneNumber: v.companyPhoneNumber,
          companyEmailAddress: v.companyEmailAddress, companyAddress: v.companyAddress,
            paymentType: v.paymentType, paysonSnippet: v.paysonSnippet});
      } else {
        // this.cookieService.delete('basket');
        this.cleanUpShoppingCart();
      }
    }
  }

  get size(): number {
    return this._data.tickets.length;
  }

  get dancers(): Array<DancerEntry> {
    return this._data.dancers;
  }

  get clientId(): string {
    return this._data.clientId;
  }

  set clientId(clientId: string) {
    this._data.clientId = clientId;
    // console.log(this._data.clientId);
  }

  get gdpr(): boolean {
    return this._data.gdpr;
  }

  set gdpr(gdpr: boolean) {
    this._data.gdpr = gdpr;
  }

  get terms(): boolean {
    return this._data.terms;
  }

  set terms(terms: boolean) {
    this._data.terms = terms;
  }

  get tickets(): Ticket[] {
    return this._data.tickets;
  }

  set companyDisplayName(companyDisplayName: string) {
    this._data.companyDisplayName = companyDisplayName;
  }
  get companyDisplayName() {
    return this._data.companyDisplayName;
  }

  set companyPhoneNumber(companyPhoneNumber: string) {
    this._data.companyPhoneNumber = companyPhoneNumber;
  }
  get companyPhoneNumber() {
    return this._data.companyPhoneNumber;
  }

  set companyEmailAddress(companyEmailAddress: string) {
    this._data.companyEmailAddress = companyEmailAddress;
  }
  get companyEmailAddress() {
    return this._data.companyEmailAddress;
  }

  set companyAddress(companyAddress: string) {
    this._data.companyAddress = companyAddress;
  }
  get companyAddress() {
    return this._data.companyAddress;
  }

  set paysonSnippet(paysonSnippet: string) {
    this._data.paysonSnippet = paysonSnippet;
  }
  get paysonSnippet() {
    return this._data.paysonSnippet;
  }


  set paymentType(paymentType: string) {
    this._data.paymentType = paymentType;
  }
  get paymentType() {
    return this._data.paymentType;
  }


  get basket(): Basket {
    return new Basket(this.dancers, this.tickets, this.clientId, this.gdpr, this.terms,
      this.companyDisplayName, this.companyPhoneNumber, this.companyEmailAddress, this.companyAddress,
      this.paymentType, this.paysonSnippet);
  }

  get totalCost() {
    return _.reduce(this._data.tickets, (sum, t: Ticket) => sum + t.event.totalPrice, 0);
  }

  saveDancer(dancerEntry: DancerEntry): void {
    this._data.dancers = _.map(this._data.dancers, ((entry) => dancerEntry[0] === entry[0] ? dancerEntry : entry));
  }

  getDancer(dancerId: string): DancerDto {
    const entry = _.find(this.dancers, (dancerEntry) => dancerEntry[0] === dancerId);
    if (entry) {
      return entry[1];
    }
  }

  public setDancerFor(currentTicket: Ticket, dancerId: string): void {
    _.find(this.tickets, (ticket: Ticket) => ticket === currentTicket).dancerId = dancerId;
    this.saveBasket();
  }

  public addTicket(event: EventDto): void {
    // console.log(event);
    this._data.tickets.push(new Ticket(event));
    this._data.tickets = _.sortBy(this._data.tickets, [(t: Ticket) => t.event.eventName]);
    // already initiated payson payment should not be valid anymore
    this.priceChangedInbasket.emit(true);
    this.saveBasket();
  }

  removeDancer(dancerId: string): any {
    _.remove(this._data.dancers, (entry) => entry[0] === dancerId);

    for (const ticket of this._data.tickets) {
      if (ticket.dancerId === dancerId) {
        ticket.dancerId = null;
      }
    }
    this.saveBasket();
  }

  addDancer(dancer: DancerDto): string {
    const dancerId = id();
    const a: [string, DancerDto] = [dancerId, dancer];
    this._data.dancers.push(a);
    this.saveBasket();
    return dancerId;

  }

  public remove(ticket: Ticket) {
    const index = this._data.tickets.indexOf(ticket);
    if (index > -1) {
      this._data.tickets.splice(index, 1);
    }
    // already initiated payson payment should not be valid anymore
    this.priceChangedInbasket.emit(true);
    this.saveBasket();
  }

  add(event: EventDto): void {
    // console.log('adding event ', event);
    // console.log(this._data.tickets);
    this._data.tickets.push(new Ticket(event));
    this._data.tickets = _.sortBy(this._data.tickets, (ticket: Ticket) => ticket.event.eventName);
    // already initiated payson payment should not be valid anymore
    this.priceChangedInbasket.emit(true);
    this.saveBasket();
  }

  getDancersFor(event: EventDto) {
    // console.log('getting dancers for ', event);
    return _.filter(this._data.tickets, (ticket) => {
      return ticket.event === event;
    });
  }

  saveBasket(): void {
    // setting expiration time for 30 minutes
    this.cookieService.set('basket', JSON.stringify(this.basket.toJs()), (30 / (24 * 60)));
  }

  private validCart(cart: any) {
    return cart.tickets && cart.clientId;
  }

  cleanUpShoppingCart() {
    this.cookieService.delete('basket');
    this._data = new CartData([], [],
      null, false, false,
      '', '', '', '', '', '');
  }
}

class CartData {
  public tickets: Ticket[];

  constructor(_tickets: Ticket[], public dancers: Array<DancerEntry>,
              public clientId: string, public gdpr: boolean, public terms: boolean,
              public companyDisplayName: string, public companyPhoneNumber: string,
              public companyEmailAddress: string, public companyAddress: string,
              public paymentType: string, public paysonSnippet: string) {
    this.tickets = _.sortBy(_tickets, [(t: Ticket) => t.event.eventName]);
  }

  private dancerArray(): any {
    const result = [];
    for (const entry of this.dancers) {
      result.push(entry);
    }
    return result;
  }

  toJs(): any {
    return Object.assign({}, {tickets: this.tickets.map(t => t.toJs()), dancers: this.dancerArray()});
  }

}

type DancerEntry = [string, DancerDto];

export class Ticket {
  public dancerId: string;
  public discountCode: string;
  public calculatedPrice: number;

  constructor(public event: EventDto) {
    this.calculatedPrice = this.price;
  }
  get price(): number {
    if (this.discountCode && this.discountCode === this.event.discountCode) {
      return this.event.discountPrice;
    } else {
      return this.event.totalPrice;
    }
  }
  static of(event: EventDto, dancerId: string): Ticket {
    const t = new Ticket(event);
    t.dancerId = dancerId;
    return t;
  }

  public hasDiscountCode(): boolean {
    return this.discountCode && this.discountCode.trim() !== '';
  }

  public toJs(): any {
    return Object.assign({}, this, {event: Object.assign({}, this.event, { media: undefined})});
  }
}

export class Basket {
  constructor(public  dancers: Array<DancerEntry>, public tickets: Ticket[],
              public clientId: string, public gdpr: boolean, public terms: boolean,
              public companyDisplayName: string, public companyPhoneNumber: string,
              public companyEmailAddress: string, public companyAddress: string,
              public paymentType: string, public paysonSnippet: string) {
  }

  public toJs(): any {
    const tickets = this.tickets.map(ticket => Object.assign({}, ticket.toJs()));
    const dancers = [];
    this.dancers.forEach((entry) => dancers.push([entry[0], entry[1]]));
    return Object.assign({}, this, {tickets, dancers});
  }
}

function addDate(key: any, value: any) {
  if (value != null
    && value.hasOwnProperty('seconds')
    && value.hasOwnProperty('nanoseconds')) {
    value.toDate = function () {
      return new Date(this.seconds);
    };
  }
  return value;
}

function id(): string {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, 9);
}
